import { AdminListView } from "./AdminListView";
import { serviceAdapter } from "./serviceAdapter";

export function ServiceAdminPage() {
  return <AdminListView adapter={serviceAdapter} />;
}
